/**
 * Group items by keys that are returned by a function.
 *
 * @returns Map
 * @param items Array of items.
 * @param fn Function that returns a key to determine the group.
 * @param map Optional function that is called to map the groups before returning them.
 */
export function groupToMap<T, K extends string | number, U = T[]>(
  items: T[],
  fn: (item: T) => K,
  map?: (key: K, item: T[]) => U
): Map<K, U> {
  let result: Map<K, U>;

  const initialGrouping: Map<K, T[]> = new Map();

  for (const item of items) {
    const group = fn(item);

    if (initialGrouping.has(group) === false) {
      initialGrouping.set(group, []);
    }

    initialGrouping.get(group).push(item);
  }

  if (map == null) {
    result = initialGrouping as any;
  } else {
    result = new Map();

    initialGrouping.forEach((group, key) => {
      result.set(key, map(key, group));
    });
  }

  return result;
}
